import type { FC } from 'react';

import LegalDocument from '@/features/legal/components/LegalDocument';
import { useRentalTermsPage } from '@/features/legal/hooks/useRentalTermsPage.hook';

const RentalTermsPage: FC = () => {
  const { content, lastUpdated } = useRentalTermsPage();

  return <LegalDocument content={content} lastUpdated={lastUpdated} />;
};

export default RentalTermsPage;
